import { Link } from "react-router-dom";
import { getAuthor, type BlogPost } from "@/pages/blog/blogData";

export default function ArticleAuthor({ post }: { post: BlogPost }) {
  const author = getAuthor(post.author);

  return (
    <div className="rounded-xl border border-background-200 bg-background-100/70 p-5 md:p-6">
      <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Sobre o autor</p>
      <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-start">
        <img
          src={author.avatar}
          alt={author.name}
          className="h-16 w-16 shrink-0 rounded-full object-cover"
        />
        <div className="min-w-0">
          <p className="font-heading text-base font-bold text-foreground-950">{author.name}</p>
          <p className="text-xs text-foreground-500">{author.role}</p>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{author.bio}</p>
          <div className="mt-3 flex flex-wrap gap-3">
            <Link
              to="/sobre"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
            >
              <i className="ri-information-line" aria-hidden="true"></i>
              Sobre a NXHOST
            </Link>
            <Link
              to="/contato"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              Falar com a equipe
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}